import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type HeroProps = {
  locale?: SupportedLocale;
};

const WHATSAPP_URL = 'https://wa.me/48889054555';

export const Hero: React.FC<HeroProps> = ({ locale = 'pl' }) => {
  const t = content[locale].hero;

  return (
    <section id={t.id} className="hero reveal is-visible">
      <div className="container hero-grid">
        <div className="hero-text">
          <div className="eyebrow">{t.eyebrow}</div>

          <h1>{t.title}</h1>

          <div className="hero-lead">
            {t.lead.map((paragraph) => (
              <p className="lead" key={paragraph}>
                {paragraph}
              </p>
            ))}
          </div>

          <ul className="hero-bullets">
            {t.bullets.map((bullet) => (
              <li key={bullet}>
                <span className="bullet-icon" aria-hidden="true">
                  ✓
                </span>
                <span>{bullet}</span>
              </li>
            ))}
          </ul>

          <div className="hero-ctas">
            {/* Primary CTA – zostaje bez zmian */}
            <a className="btn btn-primary" href={t.ctas.primary.href}>
              {t.ctas.primary.label}
            </a>

            {/* Secondary CTA – WhatsApp */}
            <a
              className="btn btn-outline"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
            >
              WhatsApp
            </a>
          </div>
        </div>

        <div className="hero-portrait-wrapper">
          <div className="hero-accent" aria-hidden="true" />
          <img
            className="hero-portrait"
            src="/Photo.png"
            alt={t.portraitAlt}
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
};
